"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingGenerateWorkleaseStatusParameterMetadataSchema = exports.PythonCsvVirtualSheetWorkleaseSchema = exports.PythonXlsxVirtualSheet2CsvWorkleaseSchema = exports.PythonXlsx2CsvWorkleaseSchema = exports.PythonReportGenerationWorkleaseSchema = exports.ResolvedOutputSchema = exports.ResolvedDocxOutputSchema = exports.ResolvedWorkbookOutputSchema = exports.ReportingGenerateFailureWorkleaseSchema = exports.ReportingGenerateCompleteWorkleaseSchema = exports.ReportingXlsxVirtualSheet2CsvEvaluateWorkleaseStruct = exports.ReportingCsvVirtualSheetEvaluateWorkleaseStruct = exports.ReportingXslx2CsvEvaluateWorkleaseSchema = exports.ReportingCsvVirtualSheetWorkleaseStruct = exports.ReportingXlsxVirtualSheet2CsvWorkleaseStruct = exports.ReportingXlsx2CsvWorkleaseSchema = exports.PythonXlsx2CsvValueSchema = exports.ReportingGenerateEvaluateWorkleaseWireSchema = exports.ReportingGenerateWorkleaseWireSchema = exports.InvoiceReportingGenerateQaWorkleaseConfigWireSchema = exports.InvoiceReportingGenerateQaWorkleaseConfigSchema = exports.ReceivablesSaleAgreementReportingGenerateQaWorkleaseConfigSchema = exports.ReceivableResponseTapePreviewReportingGenerateQaWorkleaseConfigSchema = exports.BackupServicingCertificateReportingGenerateQaWorkleaseConfigSchema = exports.FundingRequestReportingGenerateQaWorkleaseConfigSchema = exports.BorrowingBaseServicerReportingGenerateQaWorkleaseConfigSchema = exports.WorkleaseModeIterable = void 0;
const zod_1 = require("zod");
const Config_1 = require("./CreditAgreement/Config");
const Utils_1 = require("./Utils");
const FundingRequest_1 = require("./FundingRequest");
const Invoice_1 = require("./Invoice");
const Loans_1 = require("./Loans");
// Also exporting directly from "SharedReporting"
__exportStar(require("./Shared/SharedReporting"), exports);
exports.WorkleaseModeIterable = ['QA', 'Live'];
// only for QA mode
exports.BorrowingBaseServicerReportingGenerateQaWorkleaseConfigSchema = zod_1.z.object({
    borrowingBaseReportId: zod_1.z.string().nullable(),
});
// only for QA mode
exports.FundingRequestReportingGenerateQaWorkleaseConfigSchema = zod_1.z.object({
    fundingRequestId: zod_1.z.string().nullable(),
    userId: zod_1.z.string(),
    fundingRequestComponentPreviewTotalAmounts: FundingRequest_1.FundingRequestComponentTotalAmountsSchema.optional(),
});
// only for QA mode
exports.BackupServicingCertificateReportingGenerateQaWorkleaseConfigSchema = zod_1.z.object({
    servicingCycleId: zod_1.z.string().nullable(),
});
// only for QA mode
exports.ReceivableResponseTapePreviewReportingGenerateQaWorkleaseConfigSchema = zod_1.z.object({
    receivableResponseTapePreviewId: zod_1.z.string().nullable(),
    userId: zod_1.z.string(),
});
// only for QA mode
exports.ReceivablesSaleAgreementReportingGenerateQaWorkleaseConfigSchema = zod_1.z.object({
    assignedLoanTapeId: zod_1.z.string().nullable(),
});
// only for QA mode
// Factory to create domain/wire schema variants
const createInvoiceReportingGenerateQaWorkleaseConfigSchema = (invoiceSchema, invoiceComponentSchema) => zod_1.z.object({
    invoiceId: zod_1.z.string().nullable(),
    previewInvoice: invoiceSchema.nullable(),
    previewInvoiceComponentsWithInvoiceItems: zod_1.z
        .array(invoiceComponentSchema)
        .nullable(),
});
// Domain schema (with Date objects) for runtime use
exports.InvoiceReportingGenerateQaWorkleaseConfigSchema = createInvoiceReportingGenerateQaWorkleaseConfigSchema(Invoice_1.BaseInvoiceSchema, Invoice_1.InvoiceComponentWithInvoiceItemsSchema);
// Wire schema (for JSON schema generation)
exports.InvoiceReportingGenerateQaWorkleaseConfigWireSchema = createInvoiceReportingGenerateQaWorkleaseConfigSchema(Invoice_1.BaseInvoiceWireSchema, Invoice_1.InvoiceComponentWithInvoiceItemsWireSchema);
/**
 * ************************************
 * ZOD SCHEMAS FOR REPORTING GENERATE WORKLEASE
 * ************************************
 */
// Import iterables from CreditAgreement modules
const DomainEntity_1 = require("./CreditAgreement/DomainEntity");
// Config schemas for Live mode (non-nullable)
const BorrowingBaseServicerReportingGenerateWorkleaseConfigSchema = zod_1.z.object({
    borrowingBaseReportId: zod_1.z.string(),
});
const FundingRequestReportingGenerateWorkleaseConfigSchema = zod_1.z.object({
    fundingRequestId: zod_1.z.string(),
});
const BackupServicingCertificateReportingGenerateWorkleaseConfigSchema = zod_1.z.object({
    servicingCycleId: zod_1.z.string(),
});
const ReceivableResponseTapePreviewReportingGenerateWorkleaseConfigSchema = zod_1.z.object({
    receivableResponseTapePreviewId: zod_1.z.string(),
    userId: zod_1.z.string(),
});
const ReceivablesSaleAgreementReportingGenerateWorkleaseConfigSchema = zod_1.z.object({
    assignedLoanTapeId: zod_1.z.string(),
});
// DrawRequestSubmissionLenderShare schema for FundingNotice
const DrawRequestSubmissionLenderShareSchema = zod_1.z.object({
    lender: zod_1.z.object({
        organizationId: zod_1.z.string(),
        name: zod_1.z.string(),
    }),
    bankAccounts: zod_1.z.object({
        source: zod_1.z.string(),
        destination: zod_1.z.string(),
    }),
    percent: zod_1.z.number(),
    amount: zod_1.z.number(),
    applicableMargin: zod_1.z.number(),
    projectedInterest: zod_1.z.number(),
    fundingRequestComponentId: zod_1.z.string(),
});
// Wire schema version - for JSON schema generation (uses string dates)
const DrawSubmissionWireSchema = zod_1.z.object({
    global: zod_1.z.object({
        requestAmount: zod_1.z.number(),
        constraints: zod_1.z.array(zod_1.z.any()),
        pricingOptionKey: zod_1.z.string().optional(),
        targetFundingDate: zod_1.z.string().optional(),
    }),
    requests: zod_1.z.array(zod_1.z.object({
        key: zod_1.z.string(),
        name: zod_1.z.string(),
        amount: zod_1.z.number(),
        loanKey: zod_1.z.string(),
        pricingOptionKey: zod_1.z.string(),
        invoiceMechanicsKey: zod_1.z.string().optional(),
        targetFundingDate: zod_1.z.string().optional(),
        shares: zod_1.z.array(DrawRequestSubmissionLenderShareSchema),
        externalLoanId: zod_1.z.string().optional(),
        maturityDate: zod_1.z.string(),
        loanType: zod_1.z.enum(Loans_1.LoanTypes),
    })),
});
// FundingNotice config schemas - has Date field (balanceLteCreatedAt)
const FundingNoticeReportingGenerateWorkleaseConfigWireSchema = zod_1.z.object({
    fundingRequestComponents: zod_1.z.array(zod_1.z.object({
        lenderShareId: zod_1.z.string(),
        fundingRequestComponentId: zod_1.z.string(),
        balanceLteCreatedAt: zod_1.z.string().datetime().optional(),
    })),
    initiatingLenderShareId: zod_1.z.string(),
    initiatingFundingComponentId: zod_1.z.string(),
});
const FundingNoticeReportingGenerateQaWorkleaseConfigWireSchema = zod_1.z.object({
    drawSubmission: DrawSubmissionWireSchema,
    capitalProviderOrganizationId: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
    fundingRequestMode: zod_1.z.enum(['create', 'upsize', 'edit']),
    existingLoanId: zod_1.z.string().optional(),
});
const InvoiceReportingGenerateWorkleaseConfigSchema = zod_1.z.object({
    invoiceId: zod_1.z.string(),
});
const DisbursementNoticeReportingGenerateWorkleaseConfigSchema = zod_1.z.object({
    invoiceId: zod_1.z.string(),
    capitalProviderOrganizationId: zod_1.z.string(),
});
const BatchSettlementReportingGenerateWorkleaseConfigSchema = zod_1.z.object({
    batchSettlementId: zod_1.z.string(),
});
const PaymentInKindNoticeReportingGenerateWorkleaseConfigSchema = zod_1.z.object({
    invoicePaymentInKindItemId: zod_1.z.string(),
});
// Null config schemas for reports without config
const NullConfigSchema = zod_1.z.null();
// Abstract base Wire schema for all worklease types (uses string dates for JSON schema)
const AbstractReportingGenerateWorkleaseWireSchema = zod_1.z.object({
    initiatingOrganizationId: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
    creditAgreementId: zod_1.z.string(),
    reportName: zod_1.z.string(),
    reportingDate: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // FullDateStr pattern for JSON schema
    mode: zod_1.z.enum(exports.WorkleaseModeIterable),
    reportTemplateFileType: zod_1.z.enum(Config_1.Reporting.ReportTemplateFileTypeIterable),
    reportConfigType: zod_1.z.enum(DomainEntity_1.ReportConfigTypeIterable),
    sendNotifications: zod_1.z.boolean().optional(),
});
// Individual worklease Wire schemas (for JSON schema generation)
const AssetVerificationReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: NullConfigSchema,
    reportConfigType: zod_1.z.literal('assetVerification'),
});
const BorrowingBaseServicerReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: BorrowingBaseServicerReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('borrowingBaseServicerReport'),
});
const BorrowingBaseServicerReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: exports.BorrowingBaseServicerReportingGenerateQaWorkleaseConfigSchema,
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('borrowingBaseServicerReport'),
});
const MonthlyServicerReportReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: NullConfigSchema,
    reportConfigType: zod_1.z.literal('monthlyServicerReport'),
});
const BorrowingBaseCertificateReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: FundingRequestReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('borrowingBaseCertificate'),
});
const BorrowingBaseCertificateReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: exports.FundingRequestReportingGenerateQaWorkleaseConfigSchema,
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('borrowingBaseCertificate'),
});
const BackupServicingCertificateReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: BackupServicingCertificateReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('backupServicingCertificate'),
});
const BackupServicingCertificateReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: exports.BackupServicingCertificateReportingGenerateQaWorkleaseConfigSchema,
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('backupServicingCertificate'),
});
const FundingNoticeReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: FundingNoticeReportingGenerateWorkleaseConfigWireSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('fundingNotice'),
});
const FundingNoticeReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: FundingNoticeReportingGenerateQaWorkleaseConfigWireSchema,
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('fundingNotice'),
});
const FundingRequestReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: FundingRequestReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('fundingRequestServicerReport'),
});
const FundingRequestReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: exports.FundingRequestReportingGenerateQaWorkleaseConfigSchema,
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('fundingRequestServicerReport'),
});
const NoticeOfBorrowingReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: FundingRequestReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('noticeOfBorrowing'),
});
const NoticeOfBorrowingReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: exports.FundingRequestReportingGenerateQaWorkleaseConfigSchema,
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('noticeOfBorrowing'),
});
const NoticeOfPrepaymentReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: FundingRequestReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('noticeOfPrepayment'),
});
const NoticeOfPrepaymentReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: exports.FundingRequestReportingGenerateQaWorkleaseConfigSchema,
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('noticeOfPrepayment'),
});
const ReleaseNoticeReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: FundingRequestReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('releaseNotice'),
});
const ReleaseNoticeReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: exports.FundingRequestReportingGenerateQaWorkleaseConfigSchema,
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('releaseNotice'),
});
const ReceivableResponseTapePreviewReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: ReceivableResponseTapePreviewReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('receivableResponseTapePreviewServicerReport'),
});
const ReceivableResponseTapePreviewReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: exports.ReceivableResponseTapePreviewReportingGenerateQaWorkleaseConfigSchema,
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('receivableResponseTapePreviewServicerReport'),
});
const ReceivablesSaleAgreementReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: ReceivablesSaleAgreementReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('receivablesSaleAgreement'),
});
const ReceivablesSaleAgreementReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: exports.ReceivablesSaleAgreementReportingGenerateQaWorkleaseConfigSchema,
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('receivablesSaleAgreement'),
});
const InvoiceReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: InvoiceReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('invoice'),
});
// Simple config for Invoice QA mode Wire schema (avoids custom date types for JSON schema generation)
const InvoiceReportingGenerateQaWorkleaseConfigSimpleWireSchema = zod_1.z.object({
    invoiceId: zod_1.z.string().nullable(),
    previewInvoice: zod_1.z.any().nullable(), // BaseInvoice has complex nested types with custom date schemas
    previewInvoiceComponentsWithInvoiceItems: zod_1.z.array(zod_1.z.any()).nullable(), // Complex nested types
});
const InvoiceReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: InvoiceReportingGenerateQaWorkleaseConfigSimpleWireSchema,
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('invoice'),
});
const DisbursementNoticeReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: DisbursementNoticeReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('disbursementNotice'),
});
const DisbursementNoticeReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: DisbursementNoticeReportingGenerateWorkleaseConfigSchema, // Same as Live for disbursement
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('disbursementNotice'),
});
const PaymentInKindNoticeReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: PaymentInKindNoticeReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('paymentInKindNotice'),
});
const PaymentInKindNoticeReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: PaymentInKindNoticeReportingGenerateWorkleaseConfigSchema, // Same as Live
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('paymentInKindNotice'),
});
const BatchSettlementReportingGenerateWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: BatchSettlementReportingGenerateWorkleaseConfigSchema,
    mode: zod_1.z.literal('Live'),
    reportConfigType: zod_1.z.literal('batchSettlement'),
});
const BatchSettlementReportingGenerateQaWorkleaseWireSchema = AbstractReportingGenerateWorkleaseWireSchema.extend({
    config: BatchSettlementReportingGenerateWorkleaseConfigSchema, // Same as Live
    mode: zod_1.z.literal('QA'),
    reportConfigType: zod_1.z.literal('batchSettlement'),
});
// Wire schema union - for JSON schema generation
exports.ReportingGenerateWorkleaseWireSchema = zod_1.z.union([
    AssetVerificationReportingGenerateWorkleaseWireSchema,
    BorrowingBaseServicerReportingGenerateWorkleaseWireSchema,
    BorrowingBaseServicerReportingGenerateQaWorkleaseWireSchema,
    BorrowingBaseCertificateReportingGenerateWorkleaseWireSchema,
    BorrowingBaseCertificateReportingGenerateQaWorkleaseWireSchema,
    BackupServicingCertificateReportingGenerateWorkleaseWireSchema,
    BackupServicingCertificateReportingGenerateQaWorkleaseWireSchema,
    FundingNoticeReportingGenerateWorkleaseWireSchema,
    FundingNoticeReportingGenerateQaWorkleaseWireSchema,
    FundingRequestReportingGenerateWorkleaseWireSchema,
    FundingRequestReportingGenerateQaWorkleaseWireSchema,
    MonthlyServicerReportReportingGenerateWorkleaseWireSchema,
    NoticeOfBorrowingReportingGenerateWorkleaseWireSchema,
    NoticeOfBorrowingReportingGenerateQaWorkleaseWireSchema,
    NoticeOfPrepaymentReportingGenerateWorkleaseWireSchema,
    NoticeOfPrepaymentReportingGenerateQaWorkleaseWireSchema,
    ReceivableResponseTapePreviewReportingGenerateWorkleaseWireSchema,
    ReceivableResponseTapePreviewReportingGenerateQaWorkleaseWireSchema,
    ReceivablesSaleAgreementReportingGenerateWorkleaseWireSchema,
    ReceivablesSaleAgreementReportingGenerateQaWorkleaseWireSchema,
    ReleaseNoticeReportingGenerateWorkleaseWireSchema,
    ReleaseNoticeReportingGenerateQaWorkleaseWireSchema,
    InvoiceReportingGenerateWorkleaseWireSchema,
    InvoiceReportingGenerateQaWorkleaseWireSchema,
    DisbursementNoticeReportingGenerateWorkleaseWireSchema,
    DisbursementNoticeReportingGenerateQaWorkleaseWireSchema,
    PaymentInKindNoticeReportingGenerateWorkleaseWireSchema,
    PaymentInKindNoticeReportingGenerateQaWorkleaseWireSchema,
    BatchSettlementReportingGenerateWorkleaseWireSchema,
    BatchSettlementReportingGenerateQaWorkleaseWireSchema,
]);
// ReportingGenerateEvaluateWorklease Wire schema
exports.ReportingGenerateEvaluateWorkleaseWireSchema = exports.ReportingGenerateWorkleaseWireSchema.and(zod_1.z.object({
    recordId: zod_1.z.string(),
}));
// Extract a value from a particular cell in an Excel sheet.
// Moved here so it can be used by ReportingXlsx2CsvWorkleaseSchema below.
exports.PythonXlsx2CsvValueSchema = zod_1.z.object({
    name: zod_1.z.string(), // what to call the value
    // 0-indexed position in the sheet from which to obtain this value
    // E.g., cell A1 is rowIndex=0, columnIndex=0
    rowIndex: zod_1.z.int(),
    columnIndex: zod_1.z.int(),
});
exports.ReportingXlsx2CsvWorkleaseSchema = zod_1.z.object({
    // organizationId that initiated the worklease
    initiatingOrganizationId: zod_1.z.string(),
    creditFacilityId: zod_1.z.string().nullable(),
    creditAgreementId: zod_1.z.string().nullable(),
    // metadata:
    reportingDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    reportName: zod_1.z.string(),
    // xlsx location
    xlsxS3Bucket: zod_1.z.string(),
    xlsxS3Key: zod_1.z.string(),
    // extraction params. See PythonXlsx2CsvWorklease.
    sheetName: zod_1.z.string(),
    columns: zod_1.z.string().optional(),
    headerRow: zod_1.z.int().optional(),
    numRows: zod_1.z.int().optional(),
    values: zod_1.z.array(exports.PythonXlsx2CsvValueSchema).optional(),
});
exports.ReportingXlsxVirtualSheet2CsvWorkleaseStruct = zod_1.z.object({
    // organizationId that initiated the worklease
    initiatingOrganizationId: zod_1.z.string(),
    creditFacilityId: zod_1.z.string().nullable(),
    creditAgreementId: zod_1.z.string().nullable(),
    // metadata:
    reportingDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    reportName: zod_1.z.string(),
    // xlsx location
    xlsxS3Bucket: zod_1.z.string(),
    xlsxS3Key: zod_1.z.string(),
    // extraction params. See PythonXlsxVirtualSheet2CsvWorklease.
    sheets: zod_1.z.array(zod_1.z.object({
        sheetName: zod_1.z.string(),
        rows: zod_1.z.int(), // number of rows to extract starting from row 1
        // ending letter of columns to extract, optional
        // if undefined, extract all columns with text for provided rows
        // if defined, text MUST exist at least out to that column, otherwise pandas will throw
        endColumn: zod_1.z.string().optional(),
    })),
    // virtual sheet is a 2D Array of strings
    // the author of the configuration is expected to create the "csv" they want in excel
    // and we will copy into this configuration
    // the first row should be column headers, subsequent rows can string, numbers, formulas, etc
    // use "=SUM(Sheet1!A1, Sheet!A2)" for formulas
    // FORMULAS MUST BE FULLY QUALIFIED WITH SHEET NAME
    virtualSheet: zod_1.z.array(zod_1.z.array(Utils_1.SqlPrimitiveStruct)),
});
const CsvVirtualSheetCsvDetailsStruct = zod_1.z.object({
    s3Bucket: zod_1.z.string(),
    s3Path: zod_1.z.string(),
    sheetName: zod_1.z.string(),
});
exports.ReportingCsvVirtualSheetWorkleaseStruct = zod_1.z.object({
    // organizationId that initiated the worklease
    initiatingOrganizationId: zod_1.z.string(),
    creditFacilityId: zod_1.z.string().nullable(),
    creditAgreementId: zod_1.z.string().nullable(),
    // metadata:
    reportingDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    reportName: zod_1.z.string(),
    // csvs
    csvDetails: zod_1.z.array(CsvVirtualSheetCsvDetailsStruct),
    // virtual sheet is a 2D Array of strings
    // the author of the configuration is expected to create the "csv" they want in excel
    // and we will copy into this configuration
    // the first row should be column headers, subsequent rows can string, numbers, formulas, etc
    // use "=SUM(Sheet1!A1, Sheet!A2)" for formulas
    // FORMULAS MUST BE FULLY QUALIFIED WITH SHEET NAME
    virtualSheet: zod_1.z.array(zod_1.z.array(Utils_1.SqlPrimitiveStruct)),
});
exports.ReportingXslx2CsvEvaluateWorkleaseSchema = exports.ReportingXlsx2CsvWorkleaseSchema.extend({
    recordId: zod_1.z.string(), // id of a record in `ReportingGenerateWorkleaseStatus` table
});
exports.ReportingCsvVirtualSheetEvaluateWorkleaseStruct = exports.ReportingCsvVirtualSheetWorkleaseStruct.extend({ recordId: zod_1.z.string() });
exports.ReportingXlsxVirtualSheet2CsvEvaluateWorkleaseStruct = exports.ReportingXlsxVirtualSheet2CsvWorkleaseStruct.extend({ recordId: zod_1.z.string() });
// the "CompleteWorklease" is the worklease that the py generation sends back to
// reporting lambda to "complete" the report generation.  The worklease includes
// the id of the initial worklease, and the s3 path of the generated report
exports.ReportingGenerateCompleteWorkleaseSchema = zod_1.z.object({
    recordId: zod_1.z.string(), // id of a record in `ReportingGenerateWorkleaseStatus` table
    // reportOutputName (i.e. wbOutputName workbook output name for xlsx - this is contained in the CA config, but due to operating upon CA WIP, we do not
    // want to try to access this CA again after initial read, so we will pass around in workleases
    reportOutputName: zod_1.z.string(),
    reportS3Bucket: zod_1.z.string(),
    reportS3Path: zod_1.z.string(),
});
exports.ReportingGenerateFailureWorkleaseSchema = zod_1.z.object({
    recordId: zod_1.z.string(), // id of a record in `ReportingGenerateWorkleaseStatus` table
    error: zod_1.z.string(),
});
/**
 * REPORT GENERATION SERVICE
 */
const WorkbookOutputTypeIterable = ['csv', 'value', 'image'];
const WorkbookOutputCellAddressSchema = zod_1.z.object({
    row: zod_1.z.int(),
    column: zod_1.z.int(),
}); // py service accepts row col notation, we have utils in node to handle these conversions
const AbstractWorkbookOutputSchema = zod_1.z.object({
    sheetName: zod_1.z.string(), // name of output sheet
    cellAddress: WorkbookOutputCellAddressSchema,
    type: zod_1.z.enum(WorkbookOutputTypeIterable),
});
const ValueWorkoutbookOutputTypeIterable = [
    'float',
    'int',
    'string',
    'boolean',
    'null',
    'undefined',
];
const ValueWorkbookOutputSchema = AbstractWorkbookOutputSchema.extend({
    type: zod_1.z.literal('value'),
    // Use JSON Schema compatible struct (no undefined) since this is used in Python codegen
    value: Utils_1.PrimitiveForJsonSchemaStruct,
    valueType: zod_1.z.enum(ValueWorkoutbookOutputTypeIterable),
});
const CsvWorkbookOutputSchema = AbstractWorkbookOutputSchema.extend({
    type: zod_1.z.literal('csv'),
    s3Bucket: zod_1.z.string(), // do not want to use FinleyS3Location to minimize common cross language typedefs
    s3Path: zod_1.z.string(),
    includeHeader: zod_1.z.boolean(),
});
const ImageWorkbookOutputSchema = AbstractWorkbookOutputSchema.extend({
    type: zod_1.z.literal('image'),
    s3Bucket: zod_1.z.string(), // do not want to use FinleyS3Location to minimize common cross language typedefs
    s3Path: zod_1.z.string(),
});
const WorkbookOutputSchema = zod_1.z.discriminatedUnion('type', [
    ValueWorkbookOutputSchema,
    CsvWorkbookOutputSchema,
    ImageWorkbookOutputSchema,
]);
const ResolvedWorkbookoutTypeIterable = ['xlsx', 'docx'];
const AbstractResolvedOutputSchema = zod_1.z.object({
    type: zod_1.z.enum(ResolvedWorkbookoutTypeIterable),
    // reportOutputName - this is contained in the CA config, but due to operating upon CA WIP, we do not
    // want to try to access this CA again after initial read, so we will pass around in workleases
    // not particularly used within py service itself
    reportOutputName: zod_1.z.string(),
});
// some of these properties may be common with docx, we can move to
// abstract type when those properties are explicitly known
exports.ResolvedWorkbookOutputSchema = AbstractResolvedOutputSchema.extend({
    type: zod_1.z.literal('xlsx'),
    reportName: zod_1.z.string(), // metadata logging mostly
    templateS3Bucket: zod_1.z.string(), // s3 bucket for template
    templateS3Path: zod_1.z.string(), // s3 Path to template
    artifactS3Bucket: zod_1.z.string(),
    // the version of report (and therefore full output name) may not be known until time to insert into domain,
    // py service only uploads a temp file to s3, and report generation lambda
    // renames / moves into finley-reports
    artifactS3DirectoryPath: zod_1.z.string(), // does not end with trailing slash
    outputs: zod_1.z.array(WorkbookOutputSchema),
});
// not implemented, but scaffolded
exports.ResolvedDocxOutputSchema = AbstractResolvedOutputSchema.extend({
    type: zod_1.z.literal('docx'),
});
// for extensibility in future of other output types
exports.ResolvedOutputSchema = zod_1.z.discriminatedUnion('type', [
    exports.ResolvedWorkbookOutputSchema,
    exports.ResolvedDocxOutputSchema,
]);
exports.PythonReportGenerationWorkleaseSchema = zod_1.z.object({
    reportingWorkleaseId: zod_1.z.string(), // reporting_generate_worklease_status.id for tieing report generations processes together
    orgSlug: zod_1.z.string(), // orgSlug, used for logging / metadata
    subEntitySlug: zod_1.z.string().nullable(), // cfSlug, lpSlug, only used logging / metadata
    reportingDate: zod_1.z.string().nullable(), // only used logging / metadata, using string here as FullDateStr does not codegen to python well.
    version: zod_1.z.number().nullable(), // only used logging / metadata
    resolvedOutput: exports.ResolvedOutputSchema,
});
exports.PythonXlsx2CsvWorkleaseSchema = zod_1.z.object({
    reportingWorkleaseId: zod_1.z.string(), // reporting_generate_worklease_status.id for tieing report generations processes together
    // for csv extraction
    // s3 pointer to xlsx
    xlsxS3Bucket: zod_1.z.string(),
    xlsxS3Key: zod_1.z.string(),
    // extraction params
    // if no other params are given, this will extract the whole sheet
    sheetName: zod_1.z.string(), // sheet name in xlsx file
    // optionally, specify sheet extraction options to extract a portion of the sheet
    // cannot be combined with value extraction options
    columns: zod_1.z.string().optional(), // string like A:AH, if omitted, will result from all rows containing values
    // TODO(jon): headerRow really is just `firstRow` - it need not necessarily be a header.
    headerRow: zod_1.z.int().optional(), // if omitted, first row is assumed to be header, rows are zero indexed
    numRows: zod_1.z.int().optional(), // if omitted, takes all rows that have values
    // optionally, specify value extraction options to specific cells from the sheet
    // this will produce a single-line csv
    // cannot be combined with sheet extraction options
    values: zod_1.z.array(exports.PythonXlsx2CsvValueSchema).optional(),
    // where to output the csv
    outputCsvS3Bucket: zod_1.z.string(),
    outputCsvS3DirectoryPath: zod_1.z.string(), // does not end with trailing slash
    // output csv name
    reportOutputName: zod_1.z.string(),
});
// virtual sheet is a 2D Array of strings
// the author of the configuration is expected to create the "csv" they want in excel
// and we will copy into this configuration
// the first row should be column headers, subsequent rows can string, numbers, formulas, etc
// use "=SUM(Sheet1!A1, Sheet!A2)" for formulas
// FORMULAS MUST BE FULLY QUALIFIED WITH SHEET NAME
const VirtualSheetSchema = zod_1.z.array(zod_1.z.array(Utils_1.SqlPrimitiveStruct));
const SheetConfigSchema = zod_1.z.object({
    sheetName: zod_1.z.string(),
    rows: zod_1.z.int(), // number of rows to extract starting from row 1
    // ending letter of columns to extract, optional
    // if undefined, extract all columns with text for provided rows
    // if defined, text MUST exist at least out to that column, otherwise pandas will throw
    endColumn: zod_1.z.string().optional(),
});
exports.PythonXlsxVirtualSheet2CsvWorkleaseSchema = zod_1.z.object({
    reportingWorkleaseId: zod_1.z.string(), // reporting_generate_worklease_status.id for tieing report generations processes together
    // for csv extraction
    // s3 pointer to xlsx
    xlsxS3Bucket: zod_1.z.string(),
    xlsxS3Key: zod_1.z.string(),
    sheets: zod_1.z.array(SheetConfigSchema),
    virtualSheet: VirtualSheetSchema,
    // where to output the csv
    outputCsvS3Bucket: zod_1.z.string(),
    outputCsvS3DirectoryPath: zod_1.z.string(), // does not end with trailing slash
    // output csv name
    reportOutputName: zod_1.z.string(),
});
const CsvDetailSchema = zod_1.z.object({
    s3Bucket: zod_1.z.string(),
    s3Path: zod_1.z.string(),
    sheetName: zod_1.z.string(),
});
exports.PythonCsvVirtualSheetWorkleaseSchema = zod_1.z.object({
    reportingWorkleaseId: zod_1.z.string(), // reporting_generate_worklease_status.id for tieing report generations processes together
    // for csv extraction
    // s3 pointer to csv
    csvDetails: zod_1.z.array(CsvDetailSchema), // artifactSlug is passed as it will serve as "sheetName" in the in-memory workbook
    virtualSheet: VirtualSheetSchema,
    // where to output the csv
    outputCsvS3Bucket: zod_1.z.string(),
    outputCsvS3DirectoryPath: zod_1.z.string(), // does not end with trailing slash
    // output csv name
    reportOutputName: zod_1.z.string(),
});
exports.ReportingGenerateWorkleaseStatusParameterMetadataSchema = zod_1.z.object({
    // finley receivable ids, runtime variable for asset verification docx
    receivableIds: zod_1.z.array(zod_1.z.string()).optional(),
});
//# sourceMappingURL=Reporting.js.map